var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"92c2679cf71a36be223ebd58b4f0a2cf88674964"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

// not sure why client side doesn't pick up SENTRY_DSN, it only picks up NEXT_PUBLIC_SENTRY_DSN
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

const isProd = process.env.NODE_ENV === 'production'
const isCypress = process.env.NEXT_PUBLIC_CYPRESS === 'true' || process.env.CYPRESS === 'true'
const isExplicitlyDisabled = process.env.NEXT_PUBLIC_DISABLE_SENTRY === 'true'
const enabled = Boolean(isProd && !isCypress && !isExplicitlyDisabled && SENTRY_DSN)

Sentry.init({
  dsn: SENTRY_DSN,
  // Reduce sampling to avoid 429 rate limits; drop to near-zero if needed
  sampleRate: 0.2, // error events
  tracesSampleRate: 0.02, // performance transactions
  // https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-denyurls
  denyUrls: [/ezoic\.com/i, /ezojs\.com/i],
  ignoreErrors: [
    /^Script error\.?$/,
    /Blocked a frame with origin/i,
    /Refused to frame/i,
    /_ezaq|addFileOnce|getPlacementPosition|EzoicIdentity|visit_uuid not found/i,
  ],
  beforeSend(event) {
    if (!enabled) return null
    return event
  },
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  enabled,
})
